import { instance } from './config';

export const getEndDailyHistoryByVendorAccountId = (requestData) => {
   return instance.post('/dailyhistory/dates', requestData);
};
